export const NAME_TOKEN = 'TOKEN_AUTH'